import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSnackbar, SnackbarKey } from 'notistack';

interface SnackbarCloseButtonProps {
    snackbarKey: SnackbarKey;
}

export function SnackbarCloseButton({ snackbarKey }: SnackbarCloseButtonProps) {
    const { closeSnackbar } = useSnackbar();

    return (
        <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => closeSnackbar(snackbarKey)}
        >
            <CloseIcon fontSize="small" />
        </IconButton>
    );
}

export default SnackbarCloseButton;
